module.exports = __webpack_public_path__ + "static/media/avatar.8b92e6a3.JPG";